"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.M43DefaultProps = exports.M43 = void 0;

var _m = _interopRequireDefault(require("./components/m-43"));

exports.M43 = _m["default"];

var _m2 = _interopRequireDefault(require("./components/m-43.props/m-43.defaultProps"));

exports.M43DefaultProps = _m2["default"];